(function () {
  if (window.McryQuoteReady) return;
  window.McryQuoteReady = true;
  var registry = document.getElementById('mcry-quote-products');
  if (!registry) return;
  var ids = new Set(JSON.parse(registry.textContent).map(String));
  var quote = document.getElementById('mcry-quote');
  var form = document.getElementById('McryQuoteForm');
  var choice = document.getElementById('McryQuoteVariant');
  function setVariant(id) {
    if (!choice) return;
    var option = Array.from(choice.options).find(function (o) { return o.dataset.id === String(id); });
    if (option) choice.selectedIndex = option.index;
    option = choice.selectedOptions[0];
    if (!option) return;
    form.querySelector('[data-quote-id]').value = option.dataset.id;
    form.querySelector('[data-quote-sku]').value = option.dataset.sku || '';
  }
  function syncVariant() {
    var nativeId = document.querySelector('.product-information product-form-component input[name="id"]');
    var urlId = new URL(window.location.href).searchParams.get('variant');
    setVariant(nativeId ? nativeId.value : urlId);
  }
  function openQuote() {
    if (!quote) return false;
    syncVariant();
    quote.open = true;
    quote.scrollIntoView({ behavior: 'smooth', block: 'center' });
    choice.focus({ preventScroll: true });
    return true;
  }
  if (quote) {
    var anchor = document.querySelector('.product-information .buy-buttons-block');
    if (anchor) anchor.insertAdjacentElement('afterend', quote);
    if (choice) choice.addEventListener('change', function () {
      setVariant(choice.selectedOptions[0].dataset.id);
    });
    form.addEventListener('submit', function () {
      setVariant(choice.selectedOptions[0].dataset.id);
    });
    if (location.hash === '#mcry-quote' || location.search.includes('contact_posted=') || form.querySelector('.errors')) {
      quote.open = true;
    }
    if (location.hash === '#mcry-quote') openQuote();
  }
  document.querySelectorAll('product-card[data-product-id]').forEach(function (card) {
    if (!ids.has(card.dataset.productId)) return;
    var button = card.querySelector('button.mcry-card-cta');
    var productLink = card.querySelector('[ref="productCardLink"]');
    if (!button || !productLink) return;
    var link = document.createElement('a');
    link.className = button.className;
    link.textContent = button.textContent;
    link.setAttribute('aria-label', button.getAttribute('aria-label') || button.textContent);
    var target = new URL(productLink.href, location.href);
    target.hash = 'mcry-quote';
    link.href = target.href;
    button.replaceWith(link);
  });
  var original = window.MCRYOpenInbox;
  window.MCRYOpenInbox = function (event) {
    var trigger = event && event.target && event.target.closest('.mcry-product-enquire');
    if (quote && trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openQuote();
      return false;
    }
    return original ? original(event) : false;
  };
})();

